import React from "react";
import SignupComp from "../../components/auth/SignupComp";
import landlord from "../../assets/landlord.png";

const LandlordSignup = () => {
  return (
    <div>
      <SignupComp text={"Landlord"} img={landlord} />
    </div>
  );
};

export default LandlordSignup;
